module.exports = __webpack_public_path__ + "static/media/education-object-3-1-1.150be30e.svg";